import React, { useEffect, useState } from 'react'
import { DatePicker, Form, Input, Select, message } from "antd";
import { Button } from "evergreen-ui";
import { generatePath, useNavigate } from "react-router-dom";
import FireFetch from "../../Firebase/FireFetch";
import { useAuth } from "../../AuthContext/AuthContext";
import { getCallable } from "../../Firebase/functionsClient";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";

const moment = require("moment");
const AddSurvey = (props) => {
	const { canAccessModule, firebaseUser, loading: authLoading } = useAuth();
	const canCreateSurvey = canAccessModule("SURVEYS", "create");
	const [visibleUsers, setVisibleUsers] = useState([]);
	const [usersLoading, setUsersLoading] = useState(false);
	const navigate = useNavigate();
	const proceedToDetails = (id, object) => {
		navigate(generatePath("/surveys/:id", { id }), { state: { survey: object } });
	};

	const addSurvey = (values) => {
		if (!canCreateSurvey) {
			message.error("You do not have permission to create surveys.");
			return;
		}
		if (!firebaseUser) {
			message.error("Your session is not ready. Please sign in again.");
			return;
		}

		var objectID = Array(20).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz")
			.map(function (x) {
				return x[Math.floor(Math.random() * x.length)]
			}).join('');

		var timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");
		var surveyObject = values;
		surveyObject.dateCreated = timeStamp;
		surveyObject.surveyID = objectID;
		surveyObject.expires = values.expires ? values.expires.format("YYYY-MM-DDTHH:mm") : "";
		surveyObject.createdBy = firebaseUser.uid;

		const output = FireFetch.SaveTODB("surveys", objectID, surveyObject);
		output.then((result) => {
			if (result === "success") {
				props.modal(false);
				FireFetch.addLog("surveys", objectID, "Create");
				proceedToDetails(objectID, surveyObject);
			}
		});
	}

	useEffect(() => {
		let isMounted = true;

		const loadVisibleUsers = async () => {
			if (authLoading) return;
			if (!firebaseUser) {
				setVisibleUsers([]);
				return;
			}

			setUsersLoading(true);
			try {
				const res = await getCallable("listUsers")({});
				const users = Array.isArray(res?.data?.users) ? res.data.users : [];
				if (isMounted) {
					setVisibleUsers(users);
				}
			} catch (error) {
				console.error("Unable to load visible users for survey assignment:", error);
				if (isMounted) {
					setVisibleUsers([]);
				}
			} finally {
				if (isMounted) {
					setUsersLoading(false);
				}
			}
		};

		loadVisibleUsers();
		return () => {
			isMounted = false;
		};
	}, [authLoading, firebaseUser]);

	return (
		<>
			<Form
				layout="vertical"
				onFinish={addSurvey}
				className="p-3 font-Nunito"
				id='my-form'
			>
				<Form.Item label="Survey Title" name="title"
					rules={[{ required: true, message: 'Please input title!' }]}>
					<Input placeholder="enter survey title" id="title" />
				</Form.Item>
				<Form.Item label="Assigned Users" name="assignedUsers"
					rules={[{ required: true, message: 'Please select assigned users!' }]}>
					<Select placeholder="Select assigned users"
						showSearch
						mode="multiple"
						loading={usersLoading}
						optionFilterProp="children"
						filterOption={filterSelectOption}
						filterSort={sortSelectOptions}
					>
						{/* filter(x => (x.userStatus === "Active" || x.userStatus === "active")) */}
						{visibleUsers.map((item, index) => (
							<Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item
					label="Survey expiry date"
					name="expires"
					rules={[{ required: true, message: 'Please select expiry date!' }]}>
					<DatePicker
						showTime={{ format: 'HH:mm' }}
						format="YYYY-MM-DD HH:mm"
						placeholder="select survey's expiry date"
						picker={"date"}
						className="w-100" />
				</Form.Item>
				<Button id="btnSubmit" appearance="primary" htmlType="submit" disabled={!canCreateSurvey}>
					Save
				</Button>

			</Form>
		</>
	)
}

export default AddSurvey;
